export enum LogoffType {
  AutodetectByErrorCode = -1,
  AutoLogOffByTimeout = 0,
  RegularLogOff = 1,
  LogOffByIdle = 2,
  LogOffByParallelLogin = 3,
  LogOffBySuperAdmin = 4,
  CasSingleSignOff = 5,
  OrigamiSessionCleanup = 6,
  AutoLogoffFromRegistrationMode = 7,
}
